import React, { useState } from 'react';
import type { FormEvent } from 'react';
import { Dialog } from '@myosh/odin-components';
import type { ModalDialogButtonSetting } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';
import useImportAttachments from '../../record-import/use-import-attachments';
import ImportAttachments from '../../record-import/import-attachments';
import { showError } from '../../../../services/notification.service';

interface ImportAttachmentsModalProps {
  visible: boolean;
  onClose: () => void;
}

function ImportAttachmentsModal({ visible, onClose }: ImportAttachmentsModalProps) {
  const [importFiles, setImportFiles] = useState<Array<File>>();
  const [isLinkedWithSourceID, setIsLinkedWithSourceID] = useState(false);

  const { t } = useTranslation();

  const onModalClose = () => {
    setImportFiles(undefined);
    onClose();
  };

  const { startImportAttachmentsJob } = useImportAttachments();

  const uploadOnChange = (value?: File[]) => {
    setImportFiles(value);
  };

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (importFiles) {
      startImportAttachmentsJob(importFiles[0], isLinkedWithSourceID ? 'RECORD_SOURCE_ID' : 'RECORD_ID');

      onModalClose();
    } else {
      showError(t('import-attachments-failed'));
    }
  };

  const modalButtons: Array<ModalDialogButtonSetting> = [
    {
      text: t('submit'),
      name: 'submit',
      form: 'importAttachmentsForm',
      type: 'primary',
      disabled: !importFiles?.length,
    },
  ];

  return (
    <>
      {visible && (
        <Dialog
          header={t('import-attachments')}
          visible={visible}
          onClose={onModalClose}
          buttonType="submit"
          buttons={modalButtons}
        >
          <form onSubmit={onFormSubmit} id="importAttachmentsForm">
            <ImportAttachments
              onChange={uploadOnChange}
              onAttachmentsLinkedWithSourceIDChange={setIsLinkedWithSourceID}
            />
          </form>
        </Dialog>
      )}
    </>
  );
}

export default ImportAttachmentsModal;
